module.exports = __webpack_public_path__ + "de8242f4cb006e9c28f46c04414e525c.pdf";